var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    fillRule: "evenodd",
    d: "M15.833 3.6a1.067 1.067 0 1 1 0 2.133 1.067 1.067 0 0 1 0-2.133ZM18.1 4.667a2.267 2.267 0 1 0-4.534 0 2.267 2.267 0 0 0 4.534 0ZM10.833 3.6c.13 0 .234.104.234.233V5.5a.233.233 0 0 1-.234.233h-7.5A.233.233 0 0 1 3.1 5.5V3.833c0-.129.104-.233.233-.233h7.5Zm1.434.233c0-.791-.642-1.433-1.434-1.433h-7.5c-.791 0-1.433.642-1.433 1.433V5.5c0 .792.642 1.433 1.433 1.433h7.5c.792 0 1.434-.641 1.434-1.433V3.833ZM15.833 9.433a1.067 1.067 0 1 1 0 2.134 1.067 1.067 0 0 1 0-2.134ZM18.1 10.5a2.267 2.267 0 1 0-4.534 0 2.267 2.267 0 0 0 4.534 0ZM10.833 9.433c.13 0 .234.105.234.234v1.666a.233.233 0 0 1-.234.234h-7.5a.233.233 0 0 1-.233-.234V9.667c0-.13.104-.234.233-.234h7.5Zm1.434.234c0-.792-.642-1.434-1.434-1.434h-7.5c-.791 0-1.433.642-1.433 1.434v1.666c0 .792.642 1.434 1.433 1.434h7.5c.792 0 1.434-.642 1.434-1.434V9.667ZM15.833 15.267a1.067 1.067 0 1 1 0 2.133 1.067 1.067 0 0 1 0-2.133Zm2.267 1.066a2.267 2.267 0 1 0-4.534 0 2.267 2.267 0 0 0 4.534 0ZM10.833 15.267c.13 0 .234.104.234.233v1.667a.233.233 0 0 1-.234.233h-7.5a.233.233 0 0 1-.233-.233V15.5c0-.129.104-.233.233-.233h7.5Zm1.434.233c0-.792-.642-1.433-1.434-1.433h-7.5c-.791 0-1.433.641-1.433 1.433v1.667c0 .791.642 1.433 1.433 1.433h7.5c.792 0 1.434-.642 1.434-1.433V15.5Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.4166bf9af69ae5e500d953039ffa4818.svg";
export { ForwardRef as ReactComponent };